/**
 * @generated SignedSource<<e718e945cd379e8ace41b323289c6fea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutRegistrationForm_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutRegistrationMarketingOptIn_viewer">;
  readonly " $fragmentType": "CheckoutRegistrationForm_viewer";
};
export type CheckoutRegistrationForm_viewer$key = {
  readonly " $data"?: CheckoutRegistrationForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutRegistrationForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutRegistrationForm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutRegistrationMarketingOptIn_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6bb24e7e556ebd48c067c45b0f51e90d";

export default node;
